import {
  getCompanyAccess,
  getTotalCompanyByRegion,
  getLastTwelveMonth
} from "@/api/ppanalytic.api";
const fn = {
  SET_COMPANY_ACCESS: "SET_COMPANY_ACCESS",
  SET_FILTER_COMPANY_ACCESS: "SET_FILTER_COMPANY_ACCESS",
  RESET_FILTER_COMPANY_ACCESS: "RESET_FILTER_COMPANY_ACCESS",
  SET_TOTAL_COMPANY: "SET_TOTAL_COMPANY",
  SET_LAST_TWELVE_MONTH: "SET_LAST_TWELVE_MONTH",
  SET_FILTER_TOTAL_COMPANY: "SET_FILTER_TOTAL_COMPANY",
  RESET_FILTER_TOTAL_COMPANY: "RESET_FILTER_TOTAL_COMPANY",
  RESET: "RESET"
};

let todayDate = new Date();
let last_month_date = new Date(todayDate.getFullYear(), todayDate.getMonth()-1, 1);
let defaultDateRange = [
  (todayDate.getFullYear()-1) + '-' + (todayDate.getMonth()+1),
  last_month_date.getFullYear() + '-' + (last_month_date.getMonth()+1)
]
const initialState = () => ({
  company_access_details: [],
  total_company: [],
  last_twelve_month: {},
  filter_company_access: {
    maxItem: 20,
    dates: defaultDateRange,
    sort: 'times desc',
    region: 'All Regions'
  },
  filter_total_company: {
    dates: defaultDateRange,
  }
});

const state = initialState();

// getters
const getters = {
  get_comp_access: state => state.company_access_details,
  get_filter_comp_access: state => state.filter_company_access,
  get_total_company: state => state.total_company,
  get_filter_total_company: state => state.filter_total_company,
  get_last_twelve_month: state => state.last_twelve_month,
};

// actions
const actions = {
  reset({ commit }) {
    commit(fn.RESET);
  },
  async GET_COMPANY_ACCESS({ commit }, payload) {
    try {
      const resp = await getCompanyAccess(payload);
      commit(fn.SET_COMPANY_ACCESS, resp.data);
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async SET_FILTER_COMPANY_ACCESS({ commit }, payload) {
    try {
      commit(fn.SET_FILTER_COMPANY_ACCESS, payload);
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async RESET_FILTER_COMPANY_ACCESS({ commit }) {
    try {
      commit(fn.RESET_FILTER_COMPANY_ACCESS);
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async GET_TOTAL_COMPANY({ commit, rootGetters }, payload) {
    try {
      const resp = await getTotalCompanyByRegion(payload);
      if (resp.data) {
        commit(fn.SET_TOTAL_COMPANY, resp.data.totalCompany);
      }
    } catch (err) {
      console.log(err);
    }
  },
  async SET_LAST_TWELVE_MONTH({ commit, rootGetters }, payload) {
    try {
      const resp = await getLastTwelveMonth(payload);
      if (resp.data) {
        commit(fn.SET_LAST_TWELVE_MONTH, resp.data);
      }
    } catch (err) {
      console.log(err);
    }
  },
  async SET_FILTER_TOTAL_COMPANY({ commit }, payload) {
    try {
      commit(fn.SET_FILTER_TOTAL_COMPANY, payload);
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
  async RESET_FILTER_TOTAL_COMPANY({ commit }) {
    try {
      commit(fn.RESET_FILTER_TOTAL_COMPANY);
    } catch (err) {
      console.log(err);
      this.dispatch("Layout/SET_ERROR_MODAL");
    }
  },
};

// mutations
const mutations = {
  [fn.SET_COMPANY_ACCESS](state, payload) {
    state.company_access_details = payload;
  },
  [fn.SET_FILTER_COMPANY_ACCESS](state, payload) {
    state.filter_company_access = payload.data;
  },
  [fn.RESET_FILTER_COMPANY_ACCESS](state, payload) {
    state.filter_company_access = {
      maxItem: 20,
      dates: defaultDateRange,
      sort: 'times desc',
      region: 'All Regions'
    };
  },
  [fn.RESET](state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  [fn.SET_TOTAL_COMPANY](state, payload) {
    state.total_company = payload;
  },
  [fn.SET_LAST_TWELVE_MONTH](state, payload) {
    state.last_twelve_month = payload;
  },
  [fn.SET_FILTER_TOTAL_COMPANY](state, payload) {
    state.filter_total_company = payload.data;
  },
  [fn.RESET_FILTER_TOTAL_COMPANY](state) {
    state.filter_total_company = {
      dates: defaultDateRange
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
